import React from "react";

class BannerContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            marginTop: 64,
            isMobile: true,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        window.addEventListener("scroll", this.handleLitenerScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("scroll", this.handleLitenerScroll);
    }

    handleLitenerScroll = () => {
        this.handleSetMarginTop(window.scrollY);
    };

    handleResize = () => {
        const BREAKPOINT_MOBIL = 768;

        this.setState({
            ...this.state,
            isMobile: window.innerWidth <= BREAKPOINT_MOBIL,
        });
    };

    handleSetMarginTop = (scrollPosition) => {
        const INITIAL_MARGIN = 64;
        let marginTop = INITIAL_MARGIN;
        if (scrollPosition !== 0 && scrollPosition <= 64) {
            marginTop = INITIAL_MARGIN - scrollPosition;
        } else if (scrollPosition > 64) {
            marginTop = 0;
        }

        this.setState({
            ...this.state,
            marginTop,
        });
    };

    handleSetBannerStyles = (isBannerHome, srcBannerImage, srcBannerImage2) => {
        const bgColor = "#F0F2FA";

        return {
            height: this.props.isInEditor ? "80vh" : "",
            backgroundImage: isBannerHome ? `url('${srcBannerImage}'), url('${srcBannerImage2}'), linear-gradient(to bottom, #edeffc calc(100% - 72px), #E3E6FA 72px)` : bgColor,
            // backgroundColor: bgColor,
            backgroundRepeat: "no-repeat",
            backgroundPositionY: "calc(100% - 0px), calc(100% - 0px)",
            backgroundPositionX: "left, right",
            marginTop:
                isBannerHome || this.state.isMobile ? 0 : this.state.marginTop,
        };
    };


    handleIsBannerHome = (isBannerHome) => {
        if (isBannerHome) {
            return "banner-home";
        }

        return "banner-stepper";
    };

    render() {
        const { srcBannerImage, isBannerHome, srcBannerImage2 } = this.props.authoring;
        const bannerStyle = this.handleSetBannerStyles(
            isBannerHome,
            srcBannerImage,
            srcBannerImage2,
        );

        return (
            <div id="banner-container" className={`banner-container`}>
                <div
                    className={`banner-container__bg 
                    ${this.props.authoring.extraClass || ''} 
                    ${this.handleIsBannerHome(isBannerHome)}`}
                    style={bannerStyle}
                    >
                    {!isBannerHome && (
                        <img
                        className="imageMobileOnly"
                        src={this.props.authoring.srcCharacterMob}
                        alt={this.props.authoring.altImgMobile}
                        />
                        )}
                </div>
                { !isBannerHome &&
                    <div className={`main-container ${this.props.authoring.aditionalClass || ''}`}>
                        {this.props.children}
                    </div>
                }
            </div>
        );
    }
}

export default BannerContainer;
